<template>
  <span>
    <span v-if="status== 6" class="fs-600 text-primary fw-700" >(Settlement date)</span>
    <span v-else class="fs-600 text-primary fw-700">(Created date)</span>
  </span>

</template>
<script>
export default {
  name:'WDDateStatus',
  props:['status']
}
</script>
